import { NodeTypeName } from "@app/types";
import BaseNodeModel from "../BaseNodeModel";
import { Constant } from '../../const';

export default class SavePromptNodeModel extends BaseNodeModel {
    /**
     * Save Prompt node model
     * @module SavePromptNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = NodeTypeName.savePrompt;
        this.props.colorClass = "orange";
        this.props.iconClass = "save";
        this.DEFAULT_COLOR_CLASS = "orange";
        this.applyProps(props);
    }

    getConfig(key) {
        const prompt = window.apm.getNode(this.props.config.promptId);
        if (prompt) {
            if (key === "text") {
                this.props.config.text = prompt.props.config.text;
            }
        }
        return super.getConfig(key);
    }

    setConfig(key, value) {
        if (key === "text") {
            // update node inputs
            const oldInputs = this.getConfig("inputs") ? JSON.parse(JSON.stringify(this.getConfig("inputs"))) : [];
            const varReg = new RegExp("(?!\\{\\{)(" + Constant.k.SCOPE_APPLICATION + "|" + Constant.k.SCOPE_MODULE + ")\\.[a-zA-Z]{1,}[0-9a-zA-Z\\-\\_]*(?=\\}\\})", "ig");
            this.props.config["inputs"] = [];
            var m = [];
            for (var lang in value) {
                if (value.hasOwnProperty(lang)) {
                    const match = value[lang].match(varReg);
                    if (match) {
                        m = [...m, ...match];
                    }
                }
            }
            var refs = {};
            if (m) {
                for (var mi = 0; mi < m.length; mi++) {
                    const sv = m[mi].split(".");
                    var v = null;
                    if (sv[0] === Constant.k.SCOPE_APPLICATION) {
                        v = window.apm.getVariable(sv[1]);
                    }
                    if (sv[0] === Constant.k.SCOPE_MODULE) {
                        v = window.apm.getVariable(sv[1], window.apm.getCurrentDiagramWidget().props.node.id);
                    }
                    if (v) {
                        refs[m[mi]] = true;
                    }
                }
                const dedupRefs = Object.keys(refs);
                for (var i = 0; i < dedupRefs.length; i++) {
                    this.props.config["inputs"].push({
                        argumentName: dedupRefs[i],
                        type: "variable",
                        value: null,
                        varName: dedupRefs[i]
                    });
                }
            }
            // refresh reference list
            document.dispatchEvent(new CustomEvent("ev-property-item-list-refresh"));
        }
        super.setConfig(key, value);
        document.dispatchEvent(new CustomEvent("ev-property-refresh"));
    }

    getChannelContent() {
        const { isOmniChannel } = window.apm.serialized.omniChannel;
        return (isOmniChannel) ?  this.props.config.channel[this.props.config.channelLayer] : this.props.config.text;
    }

    getConfigViews() {
        const configView = [{
            type: "PromptDropdown",
            key: "promptId", label: this.getPropLabel("prompt"),
            optionName: this.getPropLabel("prompt_name"),
            removable: true
           },
        {
            type: "PlavSavedPromptKeyDropdown",
            key: "playSavedPromptId", label: this.getPropLabel("key"),
            optionName: this.getPropLabel("key"),
            removable: true
           
        }];

        const promptTxtAreas = window.apm.serialized.languages.map(lang => {
            const channelContent = this.getChannelContent();
            
            return { 
                context: this,
                type: "PromptTextarea", 
                key: "text",
                value: channelContent, 
                lang: lang.language,
                readOnly: true
            };
        });
        configView.push(...promptTxtAreas);
        return [
            ...this.getConfigViewNameField(),
            [
                {}
            ],
            ...configView,
            ...[
                { type: "hr" },
                { type: "Textarea", label: this.getPropLabel("note"), key: "note" }
            ]
        ];
    }
}
